import { Button, ButtonProps } from "@radix-ui/themes";
import { toast } from "react-hot-toast";
import { useCopyToClipboard } from "react-use";

type CopyableTextProps = { text: string | undefined } & ButtonProps;

export function CopyableText({ text: content, children }: CopyableTextProps) {
  const [_, copy] = useCopyToClipboard();

  const handleCopy = (e: React.MouseEvent) => {
    if (!content) return;

    e.stopPropagation();
    copy(content);
    toast.success("Copied to clipboard");
  };

  return (
    <Button
      variant="ghost"
      color="gray"
      size="1"
      highContrast
      onClick={handleCopy}
    >
      {children || content}
    </Button>
  );
}
